export const FOLDER_CONTENTS_STALE_TIME_MS = 10_000;
